import React from 'react';
import { getMyCurrentTeamMembership } from '../services/teamService';
import {
  loadTeamIdForLeaderImportFromCache,
  resolveTeamIdForLeaderImport,
} from '../utils/myTeamMembershipCache';

/**
 * 팀장 데이터 가져오기 버튼용 team id.
 * - LS 캐시가 있으면 즉시 표시
 * - 멤버십 head 버전 비교 후 변경 시에만 서버 본문 재조회
 */
export function useTeamIdForLeaderImport(workspaceId: string): string | null {
  const [teamIdForLeaderImport, setTeamIdForLeaderImport] = React.useState<string | null>(() => {
    const cached = loadTeamIdForLeaderImportFromCache(workspaceId);
    return cached === undefined ? null : cached;
  });

  React.useEffect(() => {
    if (!workspaceId.trim()) {
      setTeamIdForLeaderImport(null);
      return;
    }
    const cached = loadTeamIdForLeaderImportFromCache(workspaceId);
    if (cached !== undefined) {
      setTeamIdForLeaderImport(cached);
    }
    let cancelled = false;
    void getMyCurrentTeamMembership()
      .then((membership) => {
        if (cancelled) return;
        setTeamIdForLeaderImport(resolveTeamIdForLeaderImport(workspaceId, membership));
      })
      .catch(() => {
        if (!cancelled) setTeamIdForLeaderImport(null);
      });
    return () => {
      cancelled = true;
    };
  }, [workspaceId]);

  return teamIdForLeaderImport;
}
